// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cs-layout {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 16px;
  font-family: system-ui, -apple-system, sans-serif;
  color: #1a1a1a;
}

.cs-layout__header {
  margin-bottom: 24px;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 16px;
}

.cs-layout__brand {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.cs-layout__home-link {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111;
  text-decoration: none;
}

.cs-layout__preview-tag {
  font-size: 12px;
  background: #fff3cd;
  color: #664d03;
  padding: 2px 8px;
  border-radius: 999px;
}

.cs-layout__api-status {
  font-size: 13px;
  color: #666;
  margin: 8px 0;
}

.cs-layout__nav {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.cs-nav-link {
  font-size: 14px;
  color: #333;
  text-decoration: none;
}

.cs-nav-link.active {
  font-weight: 700;
  text-decoration: underline;
}

.cs-layout__footer {
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #eee;
  font-size: 13px;
  color: #666;
}

.cs-home__lead {
  color: #444;
  max-width: 640px;
}

.cs-home__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin: 20px 0;
}

.cs-card {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
}

.cs-blocked {
  border: 1px solid #f0d0d0;
  background: #fffafa;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
}

.cs-blocked__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.cs-blocked__title {
  margin: 0;
  font-size: 1.1rem;
}

.cs-blocked__reason,
.cs-blocked__note,
.cs-blocked__spec,
.cs-blocked__django {
  font-size: 14px;
  color: #444;
}

.cs-badge {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eee;
}

.cs-badge--done { background: #d1e7dd; color: #0f5132; }
.cs-badge--partial { background: #cff4fc; color: #055160; }
.cs-badge--shell { background: #e2e3e5; color: #41464b; }
.cs-badge--blocked { background: #f8d7da; color: #842029; }
.cs-badge--hybrid { background: #fff3cd; color: #664d03; }
.cs-badge--supported { background: #d1e7dd; color: #0f5132; }
.cs-badge--read-only { background: #cff4fc; color: #055160; }
.cs-badge--unsafe { background: #f8d7da; color: #842029; }
.cs-badge--unknown-staging { background: #e2d9f3; color: #432874; }

.cs-diagnostics {
  max-width: 960px;
}

.cs-diag-section {
  margin: 24px 0;
}

.cs-diag-note {
  font-size: 14px;
  color: #555;
}

.cs-diag-summary {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 10px;
}

.cs-diag-table__api {
  font-size: 12px;
  max-width: 220px;
  word-break: break-word;
}

.cs-diag-probes {
  list-style: none;
  padding: 0;
  margin: 0;
}

.cs-diag-probe {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.cs-diag-ok { color: #0f5132; }
.cs-diag-fail { color: #842029; }

.cs-staging-page {
  max-width: 960px;
}

.cs-staging-banner {
  background: #f8d7da;
  border: 1px solid #f1aeb5;
  color: #58151c;
  border-radius: 10px;
  padding: 14px 16px;
  margin: 16px 0;
}

.cs-staging-banner p {
  margin: 8px 0 0;
  font-size: 14px;
}

.cs-staging-session-dl {
  margin: 12px 0;
}

.cs-staging-session-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

.cs-staging-ids__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.cs-staging-input {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
}

.cs-staging-input input[type="text"],
.cs-staging-input input[type="file"] {
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.cs-staging-test {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 14px;
  margin: 12px 0;
  background: #fafafa;
}

.cs-staging-test__title {
  margin: 0 0 6px;
  font-size: 0.95rem;
}

.cs-staging-test__endpoint {
  font-size: 13px;
  color: #555;
  margin: 0 0 10px;
}

.cs-staging-test__inputs {
  margin-bottom: 10px;
}

.cs-staging-test__checks {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 10px 0;
  font-size: 13px;
}

.cs-staging-check {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.cs-staging-check--warn {
  color: #664d03;
}

.cs-staging-check--danger {
  color: #842029;
}

.cs-btn--danger {
  background: #842029;
  color: #fff;
  border-color: #842029;
}

.cs-staging-result {
  margin-top: 12px;
  padding: 12px;
  border-radius: 8px;
  font-size: 13px;
  border: 1px solid #ddd;
  background: #fff;
}

.cs-staging-result--ok {
  border-color: #badbcc;
  background: #f8fff9;
}

.cs-staging-result--fail {
  border-color: #f1aeb5;
  background: #fff8f8;
}

.cs-staging-result__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.cs-staging-result__meta {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 4px 12px;
  margin: 0 0 8px;
  font-size: 12px;
}

.cs-staging-result__meta dt {
  font-weight: 600;
  color: #555;
}

.cs-staging-result__meta dd {
  margin: 0;
}

.cs-staging-result__body {
  max-height: 240px;
  overflow: auto;
  font-size: 11px;
  background: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.cs-env-diag {
  border: 1px solid #d0d7de;
  border-radius: 10px;
  padding: 14px 16px;
  margin: 12px 0;
  background: #f6f8fa;
  font-size: 14px;
}

.cs-env-diag--compact {
  margin-top: 14px;
  background: #fff;
}

.cs-env-diag__title {
  margin: 0 0 10px;
  font-size: 1rem;
}

.cs-env-diag__dl {
  margin: 0 0 12px;
}

.cs-env-diag__note {
  font-size: 13px;
  color: #555;
}

.cs-env-diag__result {
  border-radius: 8px;
  padding: 12px;
  margin: 12px 0;
  border: 1px solid #ddd;
  background: #fff;
}

.cs-env-diag__result--ok {
  border-color: #badbcc;
  background: #f8fff9;
}

.cs-env-diag__result--fail {
  border-color: #f1aeb5;
  background: #fff8f8;
}

.cs-env-diag__result h4 {
  margin: 0 0 8px;
  font-size: 0.9rem;
}

.cs-env-diag__preview {
  max-height: 160px;
  overflow: auto;
  font-size: 11px;
  background: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.cs-env-diag__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-top: 12px;
}

.cs-env-diag__compare {
  font-size: 13px;
  color: #444;
  margin-top: 8px;
}

.cs-env-diag__footer {
  margin: 10px 0 0;
  font-size: 13px;
}

.cs-login-page {
  max-width: 420px;
  margin: 0 auto;
}

.cs-login-page__lead {
  color: #444;
  font-size: 14px;
}

.cs-login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 20px 0;
}

.cs-login-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
}

.cs-login-form__field input {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
}

.cs-login-form__error {
  color: #842029;
  font-size: 14px;
  margin: 0;
}

.cs-login-page__alt {
  font-size: 14px;
  margin-top: 16px;
}

.cs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.cs-table th,
.cs-table td {
  border-bottom: 1px solid #eee;
  padding: 8px 10px;
  text-align: left;
}

.cs-panel__title {
  margin-top: 0;
}

.cs-panel__error {
  color: #b00020;
}

.cs-panel__empty {
  color: #666;
}

.cs-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.cs-list__item {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.cs-list__meta {
  font-size: 13px;
  color: #666;
}

.cs-detail__dl {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 8px 16px;
}

.cs-detail__dl dt {
  font-weight: 600;
  color: #555;
}

.cs-member__links {
  margin-top: 16px;
}

.cs-hybrid-links {
  margin-top: 12px;
  font-size: 14px;
}

.cs-admin__django {
  margin-top: 16px;
  font-size: 14px;
}

.cs-auth-gate {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px;
  background: #fafafa;
  max-width: 520px;
}

.cs-auth-gate--error {
  border-color: #f0c0c0;
  background: #fffafa;
}

.cs-auth-gate__title {
  margin: 0 0 8px;
  font-size: 1.1rem;
  font-weight: 700;
}

.cs-auth-gate__sub,
.cs-auth-gate__detail {
  margin: 0 0 12px;
  font-size: 14px;
  color: #444;
}

.cs-auth-gate__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}

.cs-btn {
  display: inline-block;
  padding: 9px 14px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  border: 1px solid #ccc;
  background: #fff;
  color: #111;
}

.cs-btn--primary {
  background: #111;
  color: #fff;
  border-color: #111;
}

.cs-btn--ghost {
  background: #fff;
}

.cs-link-btn {
  background: none;
  border: none;
  padding: 0;
  color: #0645ad;
  cursor: pointer;
  text-decoration: underline;
  font: inherit;
}

.cs-session-badge {
  display: block;
  font-size: 13px;
  margin: 6px 0 10px;
  color: #444;
}

.cs-session-badge--ok { color: #0f5132; }
.cs-session-badge--anon { color: #664d03; }
.cs-session-badge--warn { color: #842029; }
.cs-session-badge--loading { color: #666; }

.cs-identity-card {
  border: 1px solid #d8e8d8;
  background: #f8fff8;
  border-radius: 10px;
  padding: 16px;
  margin: 16px 0;
}

.cs-identity-card__header {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}

.cs-identity-card__avatar {
  border-radius: 50%;
}

.cs-identity-card__name {
  margin: 0;
  font-size: 1.15rem;
}

.cs-identity-card__email {
  margin: 4px 0 0;
  color: #555;
  font-size: 14px;
}

.cs-identity-card__note {
  font-size: 13px;
  color: #666;
  margin: 12px 0 0;
}

.cs-inline-note {
  font-size: 12px;
  color: #888;
}

.cs-member-auth {
  max-width: 640px;
}

.cs-member__lead {
  color: #444;
  font-size: 14px;
  margin: 0 0 16px;
  max-width: 640px;
}

.cs-member-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
}

.cs-member-nav__link {
  font-size: 14px;
  color: #444;
  text-decoration: none;
}

.cs-member-nav__link--active {
  font-weight: 700;
  color: #111;
  text-decoration: underline;
}

.cs-dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin: 16px 0;
}

.cs-dashboard-card {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
}

.cs-dashboard-card--session {
  border-color: #d8e8d8;
  background: #fafcfa;
}

.cs-dashboard-card__title {
  margin: 0 0 10px;
  font-size: 1rem;
}

.cs-dashboard-card__dl {
  font-size: 13px;
  margin-bottom: 12px;
}

.cs-dashboard-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cs-dashboard-card__links {
  margin: 0;
  padding-left: 18px;
  font-size: 14px;
}

.cs-legacy-card {
  border: 1px solid #ece0d0;
  border-radius: 10px;
  padding: 14px;
  background: #fffaf5;
}

.cs-legacy-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.cs-legacy-card__title {
  margin: 0;
  font-size: 0.95rem;
}

.cs-legacy-card__desc,
.cs-legacy-card__phase {
  font-size: 13px;
  color: #444;
  margin: 0 0 8px;
}

.cs-legacy-card__phase {
  color: #666;
  font-style: italic;
}

.cs-legacy-card__link {
  font-size: 13px;
  color: #0645ad;
  word-break: break-all;
}

.cs-billing-section__intro {
  font-size: 14px;
  color: #444;
  margin: 0 0 16px;
}

.cs-owned-listings {
  margin-top: 20px;
}

.cs-verification {
  margin-top: 12px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
  font-size: 13px;
}

.cs-verification__heading {
  margin: 0 0 8px;
  font-weight: 600;
}

.cs-verification__list {
  margin: 0 0 8px;
  padding-left: 18px;
}

.cs-verification__meta {
  margin: 0;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/features/classicSite/styles/classicSite.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;EAIE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,cAAc,cAAc,EAAE;AAC9B,gBAAgB,cAAc,EAAE;;AAEhC;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA,wBAAwB,cAAc,EAAE;AACxC,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C,6BAA6B,WAAW,EAAE;;AAE1C;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;AACb","sourcesContent":[".cs-layout {\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 16px;\n  font-family: system-ui, -apple-system, sans-serif;\n  color: #1a1a1a;\n}\n\n.cs-layout__header {\n  margin-bottom: 24px;\n  border-bottom: 1px solid #e8e8e8;\n  padding-bottom: 16px;\n}\n\n.cs-layout__brand {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.cs-layout__home-link {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111;\n  text-decoration: none;\n}\n\n.cs-layout__preview-tag {\n  font-size: 12px;\n  background: #fff3cd;\n  color: #664d03;\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n\n.cs-layout__api-status {\n  font-size: 13px;\n  color: #666;\n  margin: 8px 0;\n}\n\n.cs-layout__nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.cs-nav-link {\n  font-size: 14px;\n  color: #333;\n  text-decoration: none;\n}\n\n.cs-nav-link.active {\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.cs-layout__footer {\n  margin-top: 32px;\n  padding-top: 16px;\n  border-top: 1px solid #eee;\n  font-size: 13px;\n  color: #666;\n}\n\n.cs-home__lead {\n  color: #444;\n  max-width: 640px;\n}\n\n.cs-home__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  margin: 20px 0;\n}\n\n.cs-card {\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 16px;\n  background: #fff;\n}\n\n.cs-blocked {\n  border: 1px solid #f0d0d0;\n  background: #fffafa;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.cs-blocked__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.cs-blocked__title {\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.cs-blocked__reason,\n.cs-blocked__note,\n.cs-blocked__spec,\n.cs-blocked__django {\n  font-size: 14px;\n  color: #444;\n}\n\n.cs-badge {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #eee;\n}\n\n.cs-badge--done { background: #d1e7dd; color: #0f5132; }\n.cs-badge--partial { background: #cff4fc; color: #055160; }\n.cs-badge--shell { background: #e2e3e5; color: #41464b; }\n.cs-badge--blocked { background: #f8d7da; color: #842029; }\n.cs-badge--hybrid { background: #fff3cd; color: #664d03; }\n.cs-badge--supported { background: #d1e7dd; color: #0f5132; }\n.cs-badge--read-only { background: #cff4fc; color: #055160; }\n.cs-badge--unsafe { background: #f8d7da; color: #842029; }\n.cs-badge--unknown-staging { background: #e2d9f3; color: #432874; }\n\n.cs-diagnostics {\n  max-width: 960px;\n}\n\n.cs-diag-section {\n  margin: 24px 0;\n}\n\n.cs-diag-note {\n  font-size: 14px;\n  color: #555;\n}\n\n.cs-diag-summary {\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 10px;\n}\n\n.cs-diag-table__api {\n  font-size: 12px;\n  max-width: 220px;\n  word-break: break-word;\n}\n\n.cs-diag-probes {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.cs-diag-probe {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n}\n\n.cs-diag-ok { color: #0f5132; }\n.cs-diag-fail { color: #842029; }\n\n.cs-staging-page {\n  max-width: 960px;\n}\n\n.cs-staging-banner {\n  background: #f8d7da;\n  border: 1px solid #f1aeb5;\n  color: #58151c;\n  border-radius: 10px;\n  padding: 14px 16px;\n  margin: 16px 0;\n}\n\n.cs-staging-banner p {\n  margin: 8px 0 0;\n  font-size: 14px;\n}\n\n.cs-staging-session-dl {\n  margin: 12px 0;\n}\n\n.cs-staging-session-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.cs-staging-ids__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.cs-staging-input {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 14px;\n}\n\n.cs-staging-input input[type=\"text\"],\n.cs-staging-input input[type=\"file\"] {\n  padding: 8px 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.cs-staging-test {\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 14px;\n  margin: 12px 0;\n  background: #fafafa;\n}\n\n.cs-staging-test__title {\n  margin: 0 0 6px;\n  font-size: 0.95rem;\n}\n\n.cs-staging-test__endpoint {\n  font-size: 13px;\n  color: #555;\n  margin: 0 0 10px;\n}\n\n.cs-staging-test__inputs {\n  margin-bottom: 10px;\n}\n\n.cs-staging-test__checks {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 10px 0;\n  font-size: 13px;\n}\n\n.cs-staging-check {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.cs-staging-check--warn {\n  color: #664d03;\n}\n\n.cs-staging-check--danger {\n  color: #842029;\n}\n\n.cs-btn--danger {\n  background: #842029;\n  color: #fff;\n  border-color: #842029;\n}\n\n.cs-staging-result {\n  margin-top: 12px;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  border: 1px solid #ddd;\n  background: #fff;\n}\n\n.cs-staging-result--ok {\n  border-color: #badbcc;\n  background: #f8fff9;\n}\n\n.cs-staging-result--fail {\n  border-color: #f1aeb5;\n  background: #fff8f8;\n}\n\n.cs-staging-result__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.cs-staging-result__meta {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 4px 12px;\n  margin: 0 0 8px;\n  font-size: 12px;\n}\n\n.cs-staging-result__meta dt {\n  font-weight: 600;\n  color: #555;\n}\n\n.cs-staging-result__meta dd {\n  margin: 0;\n}\n\n.cs-staging-result__body {\n  max-height: 240px;\n  overflow: auto;\n  font-size: 11px;\n  background: #f5f5f5;\n  padding: 8px;\n  border-radius: 4px;\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.cs-env-diag {\n  border: 1px solid #d0d7de;\n  border-radius: 10px;\n  padding: 14px 16px;\n  margin: 12px 0;\n  background: #f6f8fa;\n  font-size: 14px;\n}\n\n.cs-env-diag--compact {\n  margin-top: 14px;\n  background: #fff;\n}\n\n.cs-env-diag__title {\n  margin: 0 0 10px;\n  font-size: 1rem;\n}\n\n.cs-env-diag__dl {\n  margin: 0 0 12px;\n}\n\n.cs-env-diag__note {\n  font-size: 13px;\n  color: #555;\n}\n\n.cs-env-diag__result {\n  border-radius: 8px;\n  padding: 12px;\n  margin: 12px 0;\n  border: 1px solid #ddd;\n  background: #fff;\n}\n\n.cs-env-diag__result--ok {\n  border-color: #badbcc;\n  background: #f8fff9;\n}\n\n.cs-env-diag__result--fail {\n  border-color: #f1aeb5;\n  background: #fff8f8;\n}\n\n.cs-env-diag__result h4 {\n  margin: 0 0 8px;\n  font-size: 0.9rem;\n}\n\n.cs-env-diag__preview {\n  max-height: 160px;\n  overflow: auto;\n  font-size: 11px;\n  background: #f5f5f5;\n  padding: 8px;\n  border-radius: 4px;\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.cs-env-diag__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  margin-top: 12px;\n}\n\n.cs-env-diag__compare {\n  font-size: 13px;\n  color: #444;\n  margin-top: 8px;\n}\n\n.cs-env-diag__footer {\n  margin: 10px 0 0;\n  font-size: 13px;\n}\n\n.cs-login-page {\n  max-width: 420px;\n  margin: 0 auto;\n}\n\n.cs-login-page__lead {\n  color: #444;\n  font-size: 14px;\n}\n\n.cs-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin: 20px 0;\n}\n\n.cs-login-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 14px;\n}\n\n.cs-login-form__field input {\n  padding: 10px 12px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.cs-login-form__error {\n  color: #842029;\n  font-size: 14px;\n  margin: 0;\n}\n\n.cs-login-page__alt {\n  font-size: 14px;\n  margin-top: 16px;\n}\n\n.cs-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.cs-table th,\n.cs-table td {\n  border-bottom: 1px solid #eee;\n  padding: 8px 10px;\n  text-align: left;\n}\n\n.cs-panel__title {\n  margin-top: 0;\n}\n\n.cs-panel__error {\n  color: #b00020;\n}\n\n.cs-panel__empty {\n  color: #666;\n}\n\n.cs-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.cs-list__item {\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.cs-list__meta {\n  font-size: 13px;\n  color: #666;\n}\n\n.cs-detail__dl {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 8px 16px;\n}\n\n.cs-detail__dl dt {\n  font-weight: 600;\n  color: #555;\n}\n\n.cs-member__links {\n  margin-top: 16px;\n}\n\n.cs-hybrid-links {\n  margin-top: 12px;\n  font-size: 14px;\n}\n\n.cs-admin__django {\n  margin-top: 16px;\n  font-size: 14px;\n}\n\n.cs-auth-gate {\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 20px;\n  background: #fafafa;\n  max-width: 520px;\n}\n\n.cs-auth-gate--error {\n  border-color: #f0c0c0;\n  background: #fffafa;\n}\n\n.cs-auth-gate__title {\n  margin: 0 0 8px;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.cs-auth-gate__sub,\n.cs-auth-gate__detail {\n  margin: 0 0 12px;\n  font-size: 14px;\n  color: #444;\n}\n\n.cs-auth-gate__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.cs-btn {\n  display: inline-block;\n  padding: 9px 14px;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  text-decoration: none;\n  border: 1px solid #ccc;\n  background: #fff;\n  color: #111;\n}\n\n.cs-btn--primary {\n  background: #111;\n  color: #fff;\n  border-color: #111;\n}\n\n.cs-btn--ghost {\n  background: #fff;\n}\n\n.cs-link-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #0645ad;\n  cursor: pointer;\n  text-decoration: underline;\n  font: inherit;\n}\n\n.cs-session-badge {\n  display: block;\n  font-size: 13px;\n  margin: 6px 0 10px;\n  color: #444;\n}\n\n.cs-session-badge--ok { color: #0f5132; }\n.cs-session-badge--anon { color: #664d03; }\n.cs-session-badge--warn { color: #842029; }\n.cs-session-badge--loading { color: #666; }\n\n.cs-identity-card {\n  border: 1px solid #d8e8d8;\n  background: #f8fff8;\n  border-radius: 10px;\n  padding: 16px;\n  margin: 16px 0;\n}\n\n.cs-identity-card__header {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.cs-identity-card__avatar {\n  border-radius: 50%;\n}\n\n.cs-identity-card__name {\n  margin: 0;\n  font-size: 1.15rem;\n}\n\n.cs-identity-card__email {\n  margin: 4px 0 0;\n  color: #555;\n  font-size: 14px;\n}\n\n.cs-identity-card__note {\n  font-size: 13px;\n  color: #666;\n  margin: 12px 0 0;\n}\n\n.cs-inline-note {\n  font-size: 12px;\n  color: #888;\n}\n\n.cs-member-auth {\n  max-width: 640px;\n}\n\n.cs-member__lead {\n  color: #444;\n  font-size: 14px;\n  margin: 0 0 16px;\n  max-width: 640px;\n}\n\n.cs-member-nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.cs-member-nav__link {\n  font-size: 14px;\n  color: #444;\n  text-decoration: none;\n}\n\n.cs-member-nav__link--active {\n  font-weight: 700;\n  color: #111;\n  text-decoration: underline;\n}\n\n.cs-dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n  margin: 16px 0;\n}\n\n.cs-dashboard-card {\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 16px;\n  background: #fff;\n}\n\n.cs-dashboard-card--session {\n  border-color: #d8e8d8;\n  background: #fafcfa;\n}\n\n.cs-dashboard-card__title {\n  margin: 0 0 10px;\n  font-size: 1rem;\n}\n\n.cs-dashboard-card__dl {\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n\n.cs-dashboard-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.cs-dashboard-card__links {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 14px;\n}\n\n.cs-legacy-card {\n  border: 1px solid #ece0d0;\n  border-radius: 10px;\n  padding: 14px;\n  background: #fffaf5;\n}\n\n.cs-legacy-card__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.cs-legacy-card__title {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.cs-legacy-card__desc,\n.cs-legacy-card__phase {\n  font-size: 13px;\n  color: #444;\n  margin: 0 0 8px;\n}\n\n.cs-legacy-card__phase {\n  color: #666;\n  font-style: italic;\n}\n\n.cs-legacy-card__link {\n  font-size: 13px;\n  color: #0645ad;\n  word-break: break-all;\n}\n\n.cs-billing-section__intro {\n  font-size: 14px;\n  color: #444;\n  margin: 0 0 16px;\n}\n\n.cs-owned-listings {\n  margin-top: 20px;\n}\n\n.cs-verification {\n  margin-top: 12px;\n  padding: 12px;\n  background: #f5f5f5;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.cs-verification__heading {\n  margin: 0 0 8px;\n  font-weight: 600;\n}\n\n.cs-verification__list {\n  margin: 0 0 8px;\n  padding-left: 18px;\n}\n\n.cs-verification__meta {\n  margin: 0;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
